import React, { useState, useEffect } from 'react';
import { Table, Button, Form, InputGroup, Spinner, Card, Row, Col } from 'react-bootstrap';
import { FaSearch, FaEdit, FaPlus, FaWhatsapp } from 'react-icons/fa';
import pacientesService from '../../api/pacientesService';
import { useNavigate, useParams } from 'react-router-dom';
import { NotificationContext } from '../../contexts/notification-context';

const ListarPacientes = () => {
  const { addNotification } = React.useContext(NotificationContext);
  const { id } = useParams();
  const [pacientes, setPacientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();

  const fetchPacientes = async () => {
    setLoading(true);
    try {
      const response = await pacientesService.listar();
      setPacientes(response);
    } catch (error) {
      console.error('Erro ao buscar pacientes:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPacientes();
  }, []);

  const handleSearch = (e) => {
    setBusca(e.target.value);
  };

  const pacientesFiltrados = pacientes?.filter((paciente) =>
    paciente?.nome?.toLowerCase().includes(busca.toLowerCase())
  );

  const handleEdit = (id) => {
    navigate(`/pacientes/${id}`);
  };

  const handleNewPaciente = () => {
    navigate('/pacientes');
  };

  const formatTelefone = (telefone) => {
    const cleaned = ('' + telefone).replace(/\D/g, '');
  
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return `(${match[1]})${match[2]}-${match[3]}`;
    }
    return telefone;
  }
  
  return (
    <div className="listar-pacientes-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Lista de Pacientes</Card.Title>
          <hr />
          <Row>
            <Col md={9} className="mb-3">
              <Form>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Buscar paciente por nome..."
                    value={busca}
                    onChange={handleSearch}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
            </Col>
            <Col md={3} className="text-end">
              <Button variant="success" onClick={handleNewPaciente}>
                <FaPlus /> Novo Paciente
              </Button>
            </Col>
          </Row>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table striped bordered hover responsive className="mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Responsável</th>
                  <th>Telefone</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {pacientesFiltrados?.map((paciente) => (
                  <tr key={paciente.id}>
                    <td>{paciente.nome}</td>
                    <td>{paciente.responsavel.nome}</td>
                    <td>
                      <FaWhatsapp />
                      <a href={`https://wa.me/55${paciente.telefone}`} target="_blank" rel="noopener noreferrer">
                        {formatTelefone(paciente.telefone)}
                      </a>
                    </td>
                    <td>
                      <Button
                        style={{ backgroundColor: '#840027', borderColor: '#840027' }}
                        size="sm"
                        onClick={() => handleEdit(paciente.id)}
                      >
                        <FaEdit /> Editar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListarPacientes;